import SamButton from "./SamButton.tsx";
import {Send} from "lucide-react";
import React, {useState} from "react";
import {useOrderApi} from "../context/ApiContext.tsx";
import CancelButton from "./CancelButton.tsx";

interface AutoReplyNoProps {
    orderId: number;
    onSuccess: () => void;
    onCancel: () => void;
}

export const AutoReplyNoForm: React.FC<AutoReplyNoProps> = ({
                                                                  orderId,
                                                                  onSuccess,
                                                                  onCancel
                                                              }) => {

    const [ isSending, setIsSending ] = useState<boolean>(false);
    const orderApi = useOrderApi();

    const handleSubmit = () => {

        setIsSending(true);
        orderApi.autoReplyNo(({orderId: orderId})).then(_ => {
            onSuccess();
        }).catch(console.log)
            .finally(() => { setIsSending(false); })
    }

    const handleCancel = () => {

        onCancel();
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-4">

            <div className="flex justify-end space-x-2">
                <CancelButton
                    type="button"
                    onClick={handleCancel}
                    disabled={isSending}
                >
                    Cancel
                </CancelButton>
                <SamButton type="submit" disabled={isSending}>
                    <span className="inline-flex items-center space-x-1">
                        {isSending ? (
                            <>
                                <span className="animate-spin h-4 w-4 border-2 border-t-transparent border-white rounded-full mr-1"></span>
                                <span>Sending...</span>
                            </>
                        ) : (
                            <>
                                <Send className="h-4 w-4 mr-1" />
                                <span>Send Message</span>
                            </>
                        )}
                    </span>
                </SamButton>
            </div>

        </form>
    );
}